import { Component, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { HelperTransalaterService } from 'app/e-form/service/helper-translate.service';
import { MessageBoxComponent } from 'app/shared/message-box/message-box';

@Component({
   selector: 'app-edit-dialog',
   templateUrl: './edit-dialog.component.html',
   styleUrls: ['./edit-dialog.component.scss']
})
export class EditDialogComponent {
   _value: any;
   isEdit = false;
   _condtionReg = '\r\n';
   constructor(private dialogRef: MatDialogRef<EditDialogComponent>, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data: any,
      public translate: TranslateService, private helperTranslater: HelperTransalaterService) {
      this._value = data.join(this._condtionReg);
   }

   private prepareTmp(obj) {
      const _tmpValue = [];
      obj.forEach((element: string, index: number) => {
            _tmpValue.push(element.trim());
      });
      return _tmpValue;
   }

   save() {
      const _arrayVal = this._value.split(/\r?\n/);
      this.dialogRef.close(this.prepareTmp(_arrayVal));
   }

   reset() {
      this._value = '  ';
   }

   change() {
      this.isEdit = true;
   }

   canSave() {
      return !this._value ? true : false;
   }

   cancel(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.dont-save'),
            action: () => this._close()
         }
      };
      this.isEdit ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._close();
   }

   _ok() {
      this.save();
      return true;
   }

   _close(): boolean {
      this.dialogRef.close(false);
      return true;
   }
}
